import { render, staticRenderFns } from "./Swimlane.vue?vue&type=template&id=551c8686&scoped=true"
import script from "./Swimlane.vue?vue&type=script&lang=js"
export * from "./Swimlane.vue?vue&type=script&lang=js"
import style0 from "./Swimlane.vue?vue&type=style&index=0&id=551c8686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551c8686",
  null
  
)

export default component.exports